import React from "react";
import { Link } from "react-router-dom";

import { isRoute, ROUTES } from "~/router/constants";
import { ELEKTRA_EVENTS, ELEKTRA_FEED } from "~/screens/Hub/shared/sharedUrls";
import { customIcons as icons } from "~/ui";
import { Card } from "./Card";

interface Feature {
  icon: React.ReactNode;
  title: string;
  path: string;
}

const features: Feature[] = [
  {
    icon: <icons.Meet className="text-violet size-10" />,
    title: "Meet with an Elektra coach",
    path: ROUTES.hubMeetCoach,
  },
  {
    icon: <icons.Education className="text-violet size-8" />,
    title: "MD-vetted education",
    path: ROUTES.hubResources,
  },
  {
    icon: <icons.Conversation className="text-violet size-8" />,
    title: "Moderated community forum",
    path: ELEKTRA_FEED,
  },
  {
    icon: <icons.Calendar className="text-violet size-7" />,
    title: "Private, expert-led events",
    path: ELEKTRA_EVENTS,
  },
];

export const Features = () => (
  <section>
    <h2 className="text-indigo font-ivy mb-6 text-2xl sm:text-3xl">
      Available to you
    </h2>
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3">
      {features.map(({ icon, title, path }) => {
        const cardContent = (
          <Card className="flex h-full items-center rounded-lg hover:bg-neutral-100/50">
            <section className="flex h-full w-full items-center justify-start gap-2">
              <div className="bg-soft-purple group-hover:bg-soft-purple/50 flex size-14 grow-0 items-center justify-center rounded-full p-2 transition-colors duration-200">
                {icon}
              </div>
              <h3 className="text-indigo font-medium">{title}</h3>
            </section>
          </Card>
        );

        if (!isRoute(path)) {
          return (
            <a
              key={title}
              href={path}
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              {cardContent}
            </a>
          );
        }

        return (
          <Link key={title} to={path} className="group block">
            {cardContent}
          </Link>
        );
      })}
    </div>
  </section>
);
